package com.example.mystybag.login.model

data class VerifyEmailAddressUIState(
    val layoutInput     : String        = "",
    val description     : String        = "",
    val keyButtonType   : KeyButtonType = KeyButtonType.TYPE_NONE
)